import { WorkspaceProfileURLFieldRoot } from './WorkspaceProfileURLFieldRoot'
import { WorkspaceProfileUrlFieldInput } from './WorkspaceProfileURLFieldInput'
import { WorkspaceProfileUrlFieldError } from './WorkspaceProfileURLFieldError'

export { getValidationSchema } from './WorkspaceProfileURLFieldInput'

export const WorkspaceProfileURL = {
  Root: WorkspaceProfileURLFieldRoot,
  Input: WorkspaceProfileUrlFieldInput,
  Error: WorkspaceProfileUrlFieldError,
}
